import React from 'react';
import SecuredZone from './components/securedZone';

export const withSecurity = (
  Component: React.FunctionComponent,
  allowedRoles: string[] = []
) => () => {
  return (
    <SecuredZone roles={allowedRoles} >
      <Component />
    </SecuredZone>
  );
};